<app-notifications-list [notificationsCategory]="'new'" [authUser]="authUser"></app-notifications-list>
<app-notifications-list [notificationsCategory]="'early'" [authUser]="authUser"></app-notifications-list>
